document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initParallax();
  initTilt();
});

function initParallax() {
  var wraps = document.querySelectorAll('[data-mt-parallax]');
  if (!wraps.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  function update() {
    wraps.forEach(function (wrap) {
      var img = wrap.querySelector('[data-mt-parallax-img]');
      if (!img) return;
      var rect = wrap.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (rect.bottom < 0 || rect.top > vh) return;
      var progress = (rect.top) / vh;
      var offset = progress * -40;
      img.style.transform = 'scale(1.08) translateY(' + offset + 'px)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
}

function initTilt() {
  var cards = document.querySelectorAll('.mt-tilt');
  if (!cards.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;
  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'perspective(800px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-6px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var vh = window.innerHeight || document.documentElement.clientHeight;

  function isInView(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < vh && rect.bottom > 0;
  }

  var armed = [];
  els.forEach(function (el) {
    // Only animate elements that start off-screen below the fold — anything
    // already visible at load stays visible, never risking a hidden page.
    if (!isInView(el)) {
      el.classList.add('mt-reveal-armed');
      armed.push(el);
    }
  });
  if (!armed.length) return;

  function reveal(el) {
    el.classList.add('mt-visible');
    var i = armed.indexOf(el);
    if (i > -1) armed.splice(i, 1);
  }

  function check() {
    vh = window.innerHeight || document.documentElement.clientHeight;
    armed.slice().forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < vh - 60 && rect.bottom > 0) reveal(el);
    });
    if (!armed.length) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { check(); ticking = false; });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  check();

  // Safety net: whatever hasn't revealed itself in 4s (unexpected layout
  // shift, a stalled listener...) is forced visible. Content must never stay
  // permanently hidden because of an animation.
  setTimeout(function () {
    armed.slice().forEach(reveal);
  }, 4000);
}

function initCountUp() {
  var els = document.querySelectorAll('.mt-countup[data-target]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var target = parseFloat(el.getAttribute('data-target')) || 0;
      var decimals = (el.getAttribute('data-target').split('.')[1] || '').length;
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = (target * eased).toFixed(decimals);
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target.toFixed(decimals);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}
